import PropTypes from "prop-types";
import notificationRecipientsType from "./notificationRecipientsType";

export default PropTypes.shape({
  notificationRecipients: notificationRecipientsType.isRequired,
  notificationRecipientIds: PropTypes.arrayOf(PropTypes.number).isRequired,
});
